<template>
    <div>
        <el-dialog class="dialogDiv" :close-on-click-modal="false" :modal-append-to-body='false' :title="dialogTitle" :visible.sync="verDialogVisible" :before-close="handleCloseDialog">
            <el-form :model="verAdd" :rules="dataRules" ref="verAdd" class="ml20 mr20" label-position="left" label-width="120px" v-loading="formLoading">
                <el-form-item label="应用类型" prop="type">
                    <div v-if="this.verData.type === 'isDetail'">{{verAdd.type}}</div>
                    <el-select v-else v-model="verAdd.type" size="medium" clearable placeholder="请选择APP版本类型" @change="typeChange">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标题" prop="title">
                    <div v-if="this.verData.type === 'isDetail'">{{verAdd.title}}</div>
                    <el-input v-else v-model="verAdd.title" placeholder="请输入标题"></el-input>
                </el-form-item>
                <el-form-item label="升级版本号" prop="code">
                    <div v-if="this.verData.type === 'isDetail'">{{verAdd.code}}</div>
                    <el-input v-else v-model="verAdd.code" placeholder="请输入升级版本号"></el-input>
                </el-form-item>
                <el-form-item label="版本号" prop="version">
                    <div v-if="this.verData.type === 'isDetail'">{{verAdd.version}}</div>
                    <el-input v-else v-model="verAdd.version" type="textarea" :rows="4" placeholder="请输入版本号"></el-input>
                </el-form-item>
                <el-form-item label="是否强制升级" prop="forceFlag">
                    <div v-if="this.verData.type === 'isDetail'">{{verAdd.forceFlag}}</div>
                    <el-switch v-else v-model="verAdd.forceFlag" :active-value="1" :inactive-value="0" active-text="是" inactive-text="否" style="margin-left:-26px"></el-switch>
                </el-form-item>
                <el-form-item label="升级URL" prop="upUrl">
                    <div v-if="this.verData.type === 'isDetail'">{{verAdd.upUrl}}</div>
                    <el-input v-else type="textarea" :rows="4"	v-model="verAdd.upUrl" placeholder="请输入升级URL"></el-input>
                </el-form-item>
                <el-form-item label="升级内容" prop="upContent">
                    <div v-if="this.verData.type === 'isDetail'">{{verAdd.upContent}}</div>
                    <el-input v-else type="textarea" :rows="4"	v-model="verAdd.upContent" placeholder="请输入升级内容"></el-input>
                </el-form-item>
            </el-form>
            <div class="footer" v-if="this.verData.type !== 'isDetail'">
                <el-button @click="cancle" round>关闭</el-button>
                <el-button type="primary" @click="submit('verAdd')" round>保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as mapping from '@/utils/enumList'
import * as versionApi from '@/api/version'
export default {
    name: 'VerDialog',
    data() {
        return {
            dialogTitle: '添加新版本',
            dialogVisible: false,
            formLoading: false,
            options: mapping.getKeyVal('appType'),
            verAdd: {
                id: "",
                type: "",
                title: "",
                code: "",
                version: "",
                upContent: "",
                upUrl: "",
                forceFlag: 0
            },
            dataRules: {
                type: [
                    { required: true, message: '请选择APP版本类型', trigger: 'change' }
                ],
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入升级版本号', trigger: 'blur' }
                ],
                version: [
                    { required: true, message: '请输入版本号', trigger: 'blur' }
                ],
                upUrl: [
                    { required: true, message: '请输入升级URL', trigger: 'blur' }
                ],
                upContent: [
                    { required: true, message: '请输入升级内容', trigger: 'blur' }
                ]
            }
        }
    },
    props: {
        verDialogVisible: {
            required: true,
            type: Boolean
        },
        verData: {
            type: Object,
            required: true
        }
    },
    computed: {
        queryParams: function() {
            return {
                id: this.verAdd.id,
                type: this.verAdd.type,
                title: this.verAdd.title,
                code: this.verAdd.code,
                version: this.verAdd.version,
                upContent: this.verAdd.upContent,
                upUrl: this.verAdd.upUrl,
                forceFlag: this.verAdd.forceFlag
            }
        }
    },
    methods: {
        typeChange() {

        },
        submit(verAdd) {
            this.$refs[verAdd].validate((valid) => {
                if (valid) {
                    versionApi.versionAdd(this.queryParams).then(r=>{
                        if(r.code === 200) {
                            this.$message.success('添加成功!')
                            this.$parent.getVerList();
                            this.handleCloseDialog();
                        }
                    }).catch(e=>{})
                };
            });
        },
        cancle() {
            this.handleCloseDialog();
        },
        handleCloseDialog() {
            this.$emit('closeVerDialog');
        }
    },
    mounted() {
        if(this.verData.type === 'isAdd') { // 添加
            
        } else if(this.verData.type === 'isDetail') { // 详情
            this.dialogTitle = '版本详情';
            this.formLoading = true;
            this.verAdd = this.verData.form;
            this.formLoading = false;
        }
    }
}
</script>

<style lang="scss" scoped>
    .footer {
        margin-top: 20px;
        text-align: right;
    }
</style>